<template>
  <div style="text-align: left">
    <div v-if="loaded" class="mb-2">Общая сумма : {{ contract.cost_contract.price }}</div>
    <v-row v-for="(el, i) in schedule" :key="i" no-gutters class="mb-2 .flex-nowrap .flex-md-nowrap">
      <v-col cols="1" class="flex-grow-0 flex-shrink-0" min-width="50">
        <a-input-string class="pr-2" :model="{ name: 'numb', title: '№', type: 'string', readonly: true }" :disabled="false" :value="el.numb" :config="config" />
      </v-col>
      <v-col cols="0" class="flex-grow-1 flex-shrink-0">
        <a-input-datestring
          :model="{ name: 'date_plan', title: 'Дата (план)', readonly: (hasError && curError.id != i && (curError.field != 'value' || !curError.field)) || el.doc_id }"
          :disabled="false"
          :value="el.date_plan"
          :config="config"
          :readonly="true"
          @input="
            el.date_plan = $event;
            onInput($event, i, 'date_plan', el);
          "
          @onChange1="
            el.date_plan = $event;
            onInput($event, i, 'value', el);
          "
          :error="getError(i, 'date_plan')"
        />
      </v-col>
      <v-col cols="0" class="flex-grow-1 flex-shrink-1">
        <a-input-number
          class="px-2"
          :model="{ name: 'value', title: 'Сумма ', readonly: (hasError && curError.id != i && (curError.field != 'value' || !curError.field)) || el.doc_id }"
          :values="el"
          :disabled="false"
          :value="el.value"
          :config="config"
          @input="onInput($event, i, 'value', el)"
          :error="getError(i, 'value')"
        />
      </v-col>

      <v-col cols="1" class="flex-grow-0 flex-shrink-1">
        <v-icon v-if="el.doc_id" color="success" large> mdi-check-circle </v-icon>
        <v-btn v-else-if="!hasError || curError.id == i" elevation="5" fab small color="red" dark top right @click="onClickDel(i)">
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div class="text-left">
      <v-btn v-if="!hasError" elevation="2" fab x-small dark color="green" top left @click="onClickAdd">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <span> Итого : {{ total_value.toLocaleString() }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    object: {
      type: Object,
      default: () => {},
    },
    contract: { type: Object, default: () => {} },
    config: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      model: [
        { name: "numb", title: "Номер", type: "number", readonly: true, validator: ["req"] },
        { name: "date_plan", title: "Дата (план)", type: "date" },
        { name: "value", title: "Cумма", type: "number", validator: ["req"] },
        { name: "value_percent", title: "Cумма", type: "number", validator: ["req"] },
        { name: "value_commission", title: "Комиссия", type: "number" },
      ],
      schedule: [],
      hasError: false,
      curError: {},
      errors: {},
      loaded: false,
    };
  },
  computed: {
    data11: {
      set(v) {
        // this.$emit("input", v);
      },
      get() {
        let res = [];
        if (this.value) res = this.value;
        if (!Array.isArray(res)) res = [];
        return res;
      },
    },
    total_value() {
      let res = this.schedule.reduce((total, curr) => total + (parseFloat(curr.value) || 0), 0);
      return res;
    },
    total_percent() {
      return this.schedule.reduce((total, curr) => total + (parseFloat(curr.value_percent) || 0), 0).toLocaleString();
    },
  },
  created() {
    this.reset();
    this.getSchedule(this.object.id);
  },
  watch: {
    value(v) {
      console.log("w value");
      this.reset();
    },
    "object.id"(v) {
      this.getSchedule(v);
    },
    hasError: {
      handler(v) {
        this.$emit("setError", v);
      },
      immediate: true,
    },
  },
  methods: {
    async reset() {
      let res = [];
      this.errors = {};
      this.hasError = false;
      this.curError = {};
      if (this.value) res = [...this.value];
      if (!Array.isArray(res)) res = [];
      this.schedule = res || [];
    },

    commit() {
      this.$emit("input", this.schedule);
    },
    onClickDel(key) {
      let e = this.schedule;
      e.splice(key, 1);
      e.forEach((el, i) => {
        el.numb = i + 1;
      });
      this.schedule = e;
      this.commit();
      this.reset();
      if (this.curError?.id == key) {
        this.curError = {};
      }
    },
    onClickAdd() {
      let d = [...this.schedule];
      if (this.contract.cost_contract?.prepay) {
        if (this.schedule.length == 0) d.push({ numb: this.schedule.length + 1, date_plan: this.contract.contract_date, value: this.contract.cost_contract?.prepay });
        else d.push({ numb: this.schedule.length + 1, date_plan: null, value: this.contract.cost_contract?.price - (this.total_value || 0) });
      } else d.push({ numb: this.schedule.length + 1, date_plan: null, value: null });
      this.schedule = d;
      this.$set(this.curError, `id`, this.schedule.length - 1);
      this.hasError = true;
      this.onInput();
    },
    async onInput(e, key, field, row) {
      let err = "";
      if (key == undefined) key = this.schedule.length - 1;
      if (!row) row = this.schedule[key];
      if (field) row[field] = e;
      ["value", "date_plan"].forEach((f) => {
        if (!err) {
          if (row?.[f] === undefined || row?.[f] === null || row[f] < 0 || row.value == 0) {
            err = "Не верно заполнено";
          }
          this.$set(this.errors, `${key}-${f}`, err);
          console.log(this.errors);
          if (err) this.curError = { id: key, f };
        }
      });
      for (const f in ["value", "date_plan"]) {
      }
      this.hasError = !!err;

      if (!this.hasError) {
        this.commit();
      }
    },
    getError(key, field) {
      return this.errors[`${key}-${field}`];
    },

    async getSchedule(id) {
      this.schedule = [];
      if (!id) return;
      let resp;

      this.schedule = this.object.planning_income_data || [];

      this.loaded = true;
    },
  },
};
</script>
